import { inject, Injectable } from '@angular/core';
import { ApiAssetsAdapterService } from '@fullyops/data/assets/api-adapter';
import { Asset } from '@fullyops/data/assets/asset';
import { HistoryItem } from '@fullyops/data/history/history';
import {
  creatorWithAttachments,
  updaterWithAttachments,
} from '@fullyops/shared/with-attachments';
import { Observable } from 'rxjs';
import { AssetsRepository } from './repository';

@Injectable({ providedIn: 'root' })
export class AssetsService {
  private api = inject(ApiAssetsAdapterService);

  createRepository(): AssetsRepository {
    return new AssetsRepository(this.api);
  }

  getById(assetId: string): Observable<Asset> {
    return this.api.getById(assetId);
  }

  getHistoryById(assetId: string): Observable<HistoryItem[]> {
    return this.api.getHistoryById(assetId);
  }

  delete(assetId: string): Observable<void> {
    return this.api.delete(assetId);
  }

  readonly create = creatorWithAttachments(this.api);
  readonly update = updaterWithAttachments(this.api);
}
